$giper_baza_app_stat_page $mol_page
	home $giper_baza_app_home
		link => home_link
		name => title
	head /
		<= Main $mol_view sub / 
			<= Land $giper_baza_link_chip
				link <= home_link
				arg *
					section \glob
					^
			<= Uptime $mol_chip title <= uptime \🔴 00:00
		<= Tools
	body_content /
		<= Charts $mol_gallery items /
			<= Cpu $giper_baza_app_stat_chart metrics /
				<= Cpu_user $mol_plot_line
					title \CPU User (%)
					series_y <= cpu_user /
				<= Cpu_system $mol_plot_line
					title \CPU System (%)
					series_y <= cpu_system /
			<= Mem $giper_baza_app_stat_chart metrics /
				<= Mem_free $mol_plot_line
					title \Mem Free (MB)
					series_y <= mem_free /
				<= Mem_used $mol_plot_line
					title \Mem Used (MB)
					series_y <= mem_used /
			<= Fs_usage $giper_baza_app_stat_chart metrics /
				<= Fs_free $mol_plot_line
					title \FS Free (MB)
					series_y <= fs_free /
				<= Fs_used $mol_plot_line
					title \FS Used (MB)
					series_y <= fs_used /
			<= Fs_acting $giper_baza_app_stat_chart metrics /
				<= Fs_reads $mol_plot_line
					title \FS Reads / sec
					series_y <= fs_reads /
				<= Fs_writes $mol_plot_line
					title \FS Writes / sec
					series_y <= fs_writes /
			<= Ports $giper_baza_app_stat_chart metrics /
				<= Port_slaves $mol_plot_line
					title \Slave Ports
					series_y <= port_slaves /
				<= Port_masters $mol_plot_line
					title \Master Ports
					series_y <= port_masters /
			<= Land_count $giper_baza_app_stat_chart metrics /
				<= Land_alive $mol_plot_line
					title \Alive Lands
					series_y <= land_alive /
				<= Land_ghost $mol_plot_line
					title \Ghost Lands
					series_y <= land_ghost /
			<= Error_count $giper_baza_app_stat_chart metrics /
				<= Errors $mol_plot_line
					title \Errors
					series_y <= errors /
